import { UPDATE_GIFT_CARD, SET_GIFT_CARD_ERROR } from '../actionTypes/CartActionTypes';

// initial reducer state
const initialState = {
    giftCardNum: '',
    giftCardPin: '',
    captchaToken: '',
    captchaType: '',
    giftCardNumError: null,
    giftCardPinError: null,
    formLevelAPIError: null,
    giftCardBalances: [],
};

// default reducer function
export default function GiftCardReducer(state = initialState, action) {
    // NOSONAR
    switch (action.type) {
        case UPDATE_GIFT_CARD:
            return { ...state, ...action.payload };
        case SET_GIFT_CARD_ERROR:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
